import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VChip,
    {
      staticClass: "analyses-lpu-active-filter-chip flex-shrink-0 pr-1",
      attrs: {
        "data-qa": _vm.chipDataQa,
        color: "primary",
        "text-color": "bg-gray-0",
      },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "analyses-lpu-active-filter-chip__label text-truncate" },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        VBtn,
        {
          staticClass: "ml-1",
          attrs: {
            icon: "",
            text: "",
            light: "",
            small: "",
            color: "bg-gray-0",
            "data-qa": _vm.resetDataQa,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _setup.emit("reset")
            },
          },
        },
        [
          _c(VIcon, { attrs: { size: "18", light: "" } }, [
            _vm._v("\n      ui-icon-close-circle\n    "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }